import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, RouterModule, Routes } from '@angular/router';
import { HomeService } from '../../services/home.service';
import { AuthService } from '../../services/auth.service';
import { UtilService } from '../../services/util.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { KeysPipe } from '../../shared/keys-pipe';

declare var jQuery:any;
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  @ViewChild('imageFileUpload') imageFileUpload: ElementRef;
  showDropdown: boolean = false;
  profilePage: boolean = true;
  currentUserObj: any = {image_90:''};
  getAllCountries:any={};
  setNewPassword: any = FormGroup;
  userImageName: String = 'Upload new photo';
  currentUserImage:string='/assets/images/default_avatar.png';
  imageFile:any;
  // settingsProfileForm: any = FormGroup;
  model: any = {
    current_password: null,
    new_password: null,
    new_password_repeat: null
  };
  first_name:string= null;
  last_name:string= null;
  email:string= null;
  phone_number:Number= null;
  country:string= null;
  state:string= null;
  address:string= null;
  passwordStatus:string=null;
  digit:boolean=false;
  capital:boolean=false;
  length:boolean=false;
  count:Number=0;
  error:boolean=true;
  userUpdateError:boolean=false;
  constructor(private homeService: HomeService, private authService: AuthService, private router: Router, private fb: FormBuilder, private utilService:UtilService) { }

  ngOnInit() {
    let url = this.router.url;
    if (url.indexOf('password') > -1) {
      this.profilePage = false;
    }
    this.countries();
    this.getCurrentUserDetails();
    this.validationForInputFields();
  }

  validationForInputFields() {
    this.setNewPassword = this.fb.group({
      current_password: ['', Validators.compose([Validators.required])],
      new_password: ['', Validators.compose([Validators.required])],
      new_password_repeat: ['', Validators.compose([Validators.required])],
    });
  }
  
  getCurrentUserDetails() {
    this.utilService.userDetails().subscribe(res => {
      this.currentUserObj = res;
      if(this.currentUserObj.image_90 != null) {
        this.currentUserImage = this.currentUserObj.image_90;
      }
      this.assignValuesForInputFields();
    });
  }

  assignValuesForInputFields() {
    this.first_name = this.currentUserObj.first_name;
    this.last_name = this.currentUserObj.last_name;
    this.email = this.currentUserObj.email;
    this.phone_number = this.currentUserObj.phone_number;
    this.country = this.currentUserObj.country;
    this.state = this.currentUserObj.state;
    this.address = this.currentUserObj.address;
  }

  countries() {
    this.utilService.getCountries().subscribe(res => {
      this.getAllCountries = res;
    });
  }

  navigate(type) {
    this.clearPasswordResetInputValues();
    if (type == 'password') {
      this.profilePage = false;
    } else {
      this.assignValuesForInputFields();
      this.profilePage = true;
    }
  }

  passwordValidation(searchValue : string ) {
    this.validate(searchValue);
  }

  passwordValidationCnfrm(searchValue : string ) {
    this.validate(searchValue);
  }

  validate(value) {
    if(value.length == 1) {
      this.clearValues('WEEK');
    } else if(value.length == 0) {
      this.clearValues('');
    }
    if(/.*[0-9]/.test(value)) {
      //For digit
      this.digit = true;
      this.count =+this.count+1;
    }
    if(/.*[A-Z]/.test(value)) {
      //For Capital letter
      this.capital = true;
      this.count =+this.count+1;
    }
    if(value.length >=8) {
      //Length of 8 symbols
      this.length = true;
    }
    
    if(this.count == 1) {
      this.passwordStatus = 'WEEK';
    }else if(this.count == 2) {
      this.passwordStatus = 'NORMAL';
    }else if(this.capital && this.digit && value.length >=8) {
      this.passwordStatus = 'STRONG';
      this.error = true;
      if(this.model.new_password == this.model.new_password_repeat) {
        this.error = false;
      }
    }
  }

  clearValues(value) {
    this.digit = false;
    this.capital = false;
    this.length = false;
    this.count = 0;
    this.passwordStatus = value;
  }

  resetForm() {
    this.clearPasswordResetInputValues();
  }

  clearPasswordResetInputValues() {
    this.clearValues('');
    this.setNewPassword.reset({
      'current_password': '',
      'new_password': '',
      'new_password_repeat': ''
    });
     if(this.currentUserObj.image_90 != null) {
      this.currentUserImage = this.currentUserObj.image_90;
    } else {
      this.currentUserImage ='/assets/images/default_avatar.png';
    }
    this.userImageName = 'Upload new photo';
  }

  resetProfileForm() {
    this.assignValuesForInputFields();
  }

  forgotPassword() {
    let email = this.currentUserObj.email;
    this.authService.resetPassword(email).subscribe(res => {
      jQuery('#recover-password-success').modal('show');
      setTimeout(function() {jQuery('#recover-password-success').modal('hide');}, 4000);
    });
  }

  resetNewPassword() {
    this.authService.setPassword(this.model).subscribe(res => {
      jQuery('#change-password-success').modal('show');
      setTimeout(function() {jQuery('#change-password-success').modal('hide');}, 4000);
    });
  }

  imageUpload() {
    this.imageFileUpload.nativeElement.click();
  }

  showSideDropdown() {
    if (this.showDropdown == false) {
        this.showDropdown = true;
    } else {
        this.showDropdown = false;
    }
  }

  updateUser() {
    //Upload image.
    if(this.imageFile) {
      let formdata = new FormData();
      formdata.append("image",this.imageFile);
      this.authService.uploadImage(formdata).subscribe(res => {
      })
    }
    let body = JSON.stringify({username:this.currentUserObj.username,first_name:this.first_name,last_name:this.last_name,country:this.country,phone_number:this.phone_number,email:this.email,state:this.state,address:this.address});
    //Update user details.
    this.authService.updateUserDetails(body).subscribe(res => {
      jQuery('#change-password-success').modal('show');
      setTimeout(function() {jQuery('#change-password-success').modal('hide');location.reload();}, 4000);
    })
  }

  onFileChange(event) {
    let reader = new FileReader();
    if(event.target.files && event.target.files.length > 0) {
      this.imageFile = event.target.files[0];
      if(this.imageFile.size <=1536000) {
        this.userImageName = event.target.files[0].name;
        reader.readAsDataURL(this.imageFile);
        reader.onload = () => {
          this.currentUserImage = reader.result;
          this.userUpdateError = true;
        }
      } else {
        alert('Please upload image Maximum file size : 1.5MB')
      }
    }
  }

  onInputChange(event) {
    this.userUpdateError = true;
  }

}


// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/components/profile/profile.component.ts